export default __webpack_public_path__ + "static/reviews-for-debt-companies-579be5708ef35683b40d8e3e6086d653.png";